import React from 'react';
import PropTypes from 'prop-types';
import errorBoundary from '@ifeng-fe/errorBoundary';
import { formatImage } from '@src/common/formatImage';
import styles from './index.css';

const GridList = (props) => {
    const { navIndex, content } = props;
    // eslint-disable-next-line no-nested-ternary
    const dataList = navIndex === undefined ? content : (navIndex === 0 ? content.china : content.world);
    
    return (
        <div className={styles.gridItem}>
            {
                dataList.map((data, index) => {
                    return (
                        <a href={data.url} target="_blank" key={index} rel="noreferrer">
                            <div className={styles.item}>
                                <div className={styles.imgWp}>
                                    <img src={formatImage(data.image, 70 * 2, 70 * 2)} alt={data.name} />
                                </div>
                                <span>{data.name}</span>
                            </div>
                        </a>
                    );
                })
            }
        </div>
    );
};

GridList.propTypes = {
    content: PropTypes.oneOfType([ PropTypes.object, PropTypes.array ]),
    navIndex: PropTypes.number
};

export default errorBoundary(GridList);
